import createPaginatedListReducerWithNamedType from 'store/hoReducers/paginatedList/reducer';
import initialState from './initialState';
import * as types from './actionTypes';

const reducerHandlers = (state = initialState, action = {}) => ({
  [types.UPDATE_CONTEXT_ALL]: () => ({
    ...state,
    all: {
      ...state.all,
      data: action.payload.contexts,
    },
  }),
});

export default createPaginatedListReducerWithNamedType(
  'CONTEXT',
  initialState,
  reducerHandlers,
);
